import { render, staticRenderFns } from "./widgetCarta.vue?vue&type=template&id=5055c606&"
import script from "./widgetCarta.vue?vue&type=script&lang=js&"
export * from "./widgetCarta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports